/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 */
//入口
// import { order } from '../../api';
// import importAll from '@/tools/importAll';
// const children  = importAll(require.context('./'))

import { orderManagement } from '@/api/ajax';
import fields from '@/page/settlementCenter/projectSettled/common/fields.js';
import search from '@/page/settlementCenter/projectSettled/common/search.js';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import _fields from './fields.js';
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';
import { payTypeRowLabelFiled } from '@/common/fields/bank';
export let example = new TableRenderClass({
  fields: { ...fields, ..._fields },
  search
});

// 结算订单 详情 支付进度列表
export const listOrderPaySchedule = [
  {
    name: '订单详情 支付进度 列表',
    childMenu: [
      example.createPart({
        name: '订单详情 支付进度 列表',
        search: [
          'xiangmucanyuren',
          'shoujihao',
          'zhifuzhuangtai',
          PAY_BANK_TYPE_KEY
        ],
        list: orderManagement.listPaySchedule,
        requestNow: true,
        fields: [
          // '_superKey',
          'index',
          'xiangmucanyuren',
          'zhifujindu_shoujihao',
          'shoukuanzhanghao',
          'projectName',
          'renwuyuedu',
          'gongyingshang',
          'finishSum',
          'taskPrice',
          'zhongduanjinejiesuanheji',
          'serviceScale',
          'totalPrice',
          'payStatus',
          'finishPayDt',
          'finishGetPayDt',
          PAY_BANK_TYPE_KEY,
          payTypeRowLabelFiled[PAY_TYPE_KEY]
        ]
      })
    ]
  }
];
